import * as React from "react";
import { useCallback, useState } from "react";
import { qualifyUrl } from "util/URLUtils";
import UserNotification from "util/UserNotification";
import { DATA_LAKE_API_ROUTES } from "data-lake/Constants";
import { getDataLakeUriParams } from "data-lake/logic/Utils";
import fetch from "logic/rest/FetchProvider";
import { Button } from "components/bootstrap";
import { Link, ConfirmDialog, Pluralize } from "components/common";
import useUserDateTime from "hooks/useUserDateTime";
import DataLakeRoutes from "data-lake/Routes";
import RetrievalHelp from "data-lake/RetrievalHelp";
import useSelectedDataLake from "data-lake/hooks/useSelectedDataLake";
import DataLakeRetrievalActionForm from "data-lake/components/DataLakeActionModals/DataLakeRetrievalActionForm";
import usePermissions from "hooks/usePermissions";
const DataLakeSearchRetrieve = ({ streamIds, timeRange = null }) => {
  const { selectedDataLake } = useSelectedDataLake();
  const [showRetrievalModal, setShowRetrievalModal] = useState(false);
  const [showInfoModal, setShowInfoModal] = useState(false);
  const { userTimezone } = useUserDateTime();
  const { isPermitted } = usePermissions();
  const onRetrieveSubmit = useCallback(
    (values) => {
      const uriParams = getDataLakeUriParams(values, userTimezone);
      const { stream_ids, inclusion_type, field_filters, operator, data_lake_id } = values;
      fetch("POST", qualifyUrl(`${DATA_LAKE_API_ROUTES.DataLakeAPIController.bulk_retrieval().url}?${uriParams}`), {
        data_lake_id,
        stream_ids,
        inclusion_type,
        field_filters,
        operator
      }).then(() => {
        UserNotification.success("Data Lake retrieve jobs was successfully submitted.", "Success");
        setShowInfoModal(true);
      }).catch((error) => {
        UserNotification.error(`An error occurred while submitting retrieval job. ${error}`);
      }).finally(() => {
        setShowRetrievalModal(false);
      });
    },
    [userTimezone]
  );
  const progressOverview = isPermitted("data_lake_config:read") ? /* @__PURE__ */ React.createElement(React.Fragment, null, "click ", /* @__PURE__ */ React.createElement(Link, { to: DataLakeRoutes.ARCHIVE.LIST }, "Data Lake overview page")) : /* @__PURE__ */ React.createElement(React.Fragment, null, "contact your administrator");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Button, { bsStyle: "link", onClick: () => setShowRetrievalModal(true) }, "From ", streamIds.length, " ", /* @__PURE__ */ React.createElement(Pluralize, { singular: "stream", plural: "streams", value: streamIds.length })), showRetrievalModal && /* @__PURE__ */ React.createElement(
    DataLakeRetrievalActionForm,
    {
      modalTitle: "Restore Data Lake data",
      defaultTimeRange: timeRange,
      show: showRetrievalModal,
      onHide: () => setShowRetrievalModal(false),
      submitButtonText: "Retrieve",
      dataLakeId: selectedDataLake.id,
      streamIds,
      onSubmit: onRetrieveSubmit
    },
    /* @__PURE__ */ React.createElement("p", null, "You are about to retrieve ", streamIds.length, " streams."),
    /* @__PURE__ */ React.createElement(RetrievalHelp, null)
  ), showInfoModal && /* @__PURE__ */ React.createElement(
    ConfirmDialog,
    {
      show: true,
      onConfirm: () => setShowInfoModal(false),
      hideCancelButton: true,
      title: "Data Lake retrieval",
      btnConfirmText: "Ok"
    },
    "Retrieval jobs for the selected stream were submitted successfully. To check the progress ",
    progressOverview,
    ". Once the job is done the retrieved messages will be available on search results."
  ));
};
export default DataLakeSearchRetrieve;
